jQuery(function(){
    if ($('#top-links .logo').attr('title') == 'Stickers Maken'){
        var elem = $('section#menu a[href="stickers-bestellen/"]');
        if (elem.length > 0){
            elem.attr('title', 'Stickers bestellen');
            elem.find('.text-menu').text('Stickers bestellen');
        }
    }

    $(document).ready(function() {
        $( "#tabs" ).tabs({
            event: "mouseover"
        });
    });

    $(document).ready(function() {
        $( ".tooltip" ).tooltip({
            show: false,
            hide: false,
            position: {
                my: "center bottom",
                at: "center top",
            }
        });
        $('.form-login-login').click(function(){
            $(this).closest('form').submit();
            return false;
        })
    });

    

    $(function() {
        $('.betaal-list li').click(function(){
            $('.betaal-list li').removeClass('active');
            $(this).addClass('active');
        });
    });

    $(function() {
        $('.match-height').matchHeight();
    });
    $(function() {
        $('.serv__item').matchHeight();
    });

    var hide = true;
    var shown = false;
    $(document).ready(function() {
        $('.horizontaal-nav .mainitem-container.first').hover(function(){
            if (!shown){
                $('.menu-block').fadeIn(250);
                shown = true;
            }
        }, function(e){
            setTimeout(function(){
                if (hide){
                    $('.menu-block').fadeOut(250);
                    shown = false;
                }
                console.log('hide:' + hide);
            }, 200); 
        });
 
        $('.menu-block').hover(function(){
            shown = true;
            hide = false;
        }, function(e){
            hide = true;
            $('.menu-block').fadeOut(250);
            shown = false;
        });
    });


    $(document).ready(function() {

        // contact pagina
        if ($('#form_1_form').length > 0){

            // selecteer juiste persoon
            var p = getParameterByName('p');
            console.log('p', p);
            if (p){
                var input = $(':input[data-value="' + p + '"]');
                if (input.length > 0){
                    input.prop('checked', true);
                }
            }

            // contactpagina groeen vinkjes
            $('#form_1_form :input').keyup(function(){
                var checkWrapper = $(this).prev('.form-mod-item__check');
                if (checkWrapper.length > 0){
                    if ($(this).val().length > 0){
                        checkWrapper.css('display', 'flex');
                    } else {
                        checkWrapper.hide();
                    }
                }
            });
        }




        if ($('#zakelijke_klant_1').length > 0){
            toggleAfwijkendAdres('afleveradres', $('#afwijkend-afleveradres').is(':checked'));
        }


        $('.gen-block-2 .gem-plak-title').hover(function(){     
            $(this).toggleClass('gem-plak-title-hover');
        });     
        $('.gen-block-2 .gem-plak-title').click(function(){     
            $('.gen-block-2 .gem-plak-title').removeClass('gem-plak-title-selected');
            $(this).toggleClass('gem-plak-title-selected');
        });
    });
    
    $(document).ready(function() { 
        $('.gen-block-5 .oplage-label').click(function(){
            $('.gen-block-5 .oplage-label').removeClass('oplage-label-active');
            $(this).addClass('oplage-label-active');
        });
    });
    

    $(document).ready(function() {       
        $('.gen-block-2 .gen-item').hover(function(){     
            $(this).toggleClass('gen-hover');
        });
        $('.gen-block-3 .gen-item').hover(function(){
            $(this).toggleClass('gen-hover');
        });
        $('.gen-block-4 .gen-item').hover(function(){
            $(this).toggleClass('gen-hover');
        });
        $('.del-block').hover(function(){
            if ($(this).find('.bold-hover').length > 0){
                $(this).find($('.bold-hover')).css('font-weight', 'bold');
            }
        },  function(){
            if ($(this).find('.bold-hover').length > 0){
                $(this).find($('.bold-hover')).css('font-weight', 'normal');
            }
        })
    });


    /*
    $('#product-detail-tekst-tekst').readmore({
        speed: 600,
        collapsedHeight: 116,  
        moreLink: '<a href="#">Lees meer</a>',  
        lessLink: '<a href="#">Lees minder</a>'
    });
    */

    $('.menu-left-half-block ul li a').hover(function(){

        $('.menu-right-title').html($(this).attr('data-title'));
        var id = $(this).attr('data-id');
        var content = $('#' + id).html();
        $('.menu-right-text').html(content);
        $('.menu-right-img').attr('src', $(this).attr('data-image'));

    });


    $('.product-detail-read-more').click(function(){
        // $(this).hide();
        // $('#product-read-more').fadeIn(500);
        $('.tab3 a').click();
        $('html, body').animate({
            scrollTop: $("#responsiveTabsDemo").offset().top - 30
        }, 350);
        return false;
    });

        
    /*
    if(window.stickersmaken === true) {
        $("body *").contents().each(function () {
            if (this.nodeType == 3)
                this.nodeValue = this.nodeValue.replace("stickersbestellen.nl", "stickersmaken.be");
            if (this.nodeType == 3)
                this.nodeValue = this.nodeValue.replace("Stickersbestellen.nl", "Stickersmaken.be");
            if (this.nodeType == 3)
                this.nodeValue = this.nodeValue.replace("Stickers bestellen", "Stickers maken");
            if (this.nodeType == 3)
                this.nodeValue = this.nodeValue.replace("Stickersbestellen", "Stickersmaken");
        });

        $a = $('.footer-blok-contact-links a');
        $a.text($a.text().replace('stickersbestellen.com', 'stickersmaken.be'));
        $a.attr('href', ($a.attr('href').replace('stickersbestellen.com', 'stickersmaken.be')));
        
        var title = document.title;
        document.title =  
    }
    */

    $('.slider-home').slick({
        dots: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false
      });

    var form = $('.ajax-form-submit');
    if (form.length > 0)
    {
        form.submit(function(){
            $.fancybox.showLoading();
            $.ajax({
                url: form.attr('href'),
                type: 'post',
                data: form.serialize(),
                success: function(data)
                {
                    $.fancybox(data);
                    $.fancybox.hideLoading();
                }
            });
            return false;
        });
    }

    $(".form-mod-item-container-standaard").click(function(){
        $( ".form-mod-item-container-standaard span" ).fadeOut(500);
    });

    $(':input[name="custom-aantal"]').on('click', function(){
        $('#oplage-optie-custom').trigger('click');
    });

     
    jQuery(".disable-scroll").click(function(){
        jQuery('.disable-scroll').fadeOut();
    });
    
    // functie die ervoor zorgt dat hoofditems met subitems niet klikbaar zijn
    jQuery('.horizontaal-nav li a, .horizontaal-nav-2 li a').each(function(){
        var li = $(this).parent('li:first');
        var submenu = li.find('ul.submenu');
        var submenu2 = li.find('.submenu-2');
        if (submenu.length > 0 || submenu2.length > 0)
        {
           jQuery(this).css('cursor','default');
            jQuery(this).click(function(){
                return false;
            });
        }
    });
    
    jQuery('.faq-container h3').click(function(e){
        e.preventDefault();
        jQuery(this).closest('li').find('p').slideToggle();
        jQuery(this).closest('li').find('ul').slideToggle();
        jQuery(this).closest('li').find('h4').slideToggle();
        jQuery(this).closest('li').find('h3').toggleClass("active");
    });
    if ($('.faq-container h3').length > 0)
    {
        var url = window.location.href;
        var pos = url.indexOf('#');
        if (pos !== -1)
        {
            var anchor = url.substring( (pos+1), url.length);
            if ($('a[name="' + anchor + '"]').length > 0)
            {
                $('a[name="' + anchor + '"]').trigger('click');
            }
        }
    }
    
    $('.product-slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3 
            }
          },
          {
            breakpoint: 999,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600, 
            settings: {
              slidesToShow: 1
            } 
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
    });

    $('.form__label-tooltip .fa-info-circle').hover(function(){
        $(this).parent().toggleClass('form__label-tooltop-open');
    });

    $('.product-slider .slick-prev').text('Terug bladeren')
    $('.product-slider .slick-next').text('Verder bladeren')

    setTimeout(function() {
        $('.meldingen-wrapper .melding').fadeOut('slow');
    }, 2000);
    

    
    jQuery('.fancybox').fancybox({
        'Width' : 600,
        'Height' : 450,
        beforeLoad: function(data){   
            jQuery('.debugmsgs').remove();
        }
    });
    
    jQuery('.content-fancybox-gallery .fancybox').each(function(){
        jQuery(this).attr('data-fancybox-group','data-fancybox-group');
    });
    
    jQuery('.fancybox-ajax').fancybox({
        type        : 'ajax',                 
        Width : 600,
        Height : 450,        
        beforeLoad  : function(data){
                          jQuery('.debugmsgs').remove();
                      },
        afterShow   : function (){
            JSInit(); 
        }
    });
    
    jQuery('.fancybox-iframe2').fancybox({
        'type' : 'iframe',
        'titleShow' : false,
        'transitionIn' : 'elastic',
        'transitionOut' : 'elastic',
        'padding' : 0,
        'Width' : 600,
        'Height' : 450,
        'maxWidth' : 800,
        'maxHeight' : 450,
        'fitToView' : false,
        'autoScale' : true
    });
    
    jQuery(".form-mod-opmerking").click(function(){
        jQuery(this).find(".form-mod-opmerking-balloon").toggleClass("form-mod-opmerking-balloon-show");
    }); 
    
    jQuery(".form-mod-opmerking-balloon").mouseout(function(){
        jQuery(".form-mod-opmerking-balloon").removeClass("form-mod-opmerking-balloon-show");
    });
    
    jQuery(this).mouseout(function(){
        jQuery(this).find(".form-mod-opmerking-balloon").removeClass("form-mod-opmerking-balloon-show");
    });
        
    jQuery(".verzending-keuze").change(function(){
        jQuery(".verzending-keuze").removeClass("verzending-keuze-selected");
        jQuery(this).addClass("verzending-keuze-selected");
    });
        
    jQuery.repairLink2Anchor();

    if(jQuery.timepicker)
    {
        jQuery.timepicker.regional['nl'] = {
            currentText: 'Nu',
            closeText: 'Sluiten',
            ampm: false,
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P'],
            timeFormat: 'hh:mm',
            timeSuffix: '',
            timeOnlyTitle: 'Kies een tijd',
            timeText: 'Tijd',
            hourText: 'Uur',
            minuteText: 'Minuut',
            secondText: 'Seconde',
            millisecText: 'Milliseconde',
            timezoneText: 'Tijdszone'};
        jQuery.timepicker.setDefaults($.timepicker.regional['nl']);
        jQuery(".datetime").datetimepicker();
        jQuery(".time").timepicker({});
    }
    if(jQuery.datepicker)
    {
        jQuery.datepicker.regional['nl'] = {
            closeText: 'Sluiten',
            prevText: 'Vorige maand',
            nextText: 'Volgende maand',
            currentText: 'Vandaag',
            monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
            monthNamesShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
            dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
            dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
            dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            weekHeader: 'Wk',
            dateFormat: 'd MM yy',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            changeMonth: true,
            changeYear: true,
            yearRange: "-100:+100"};
        jQuery.datepicker.setDefaults($.datepicker.regional['nl']);
        jQuery(".date").datepicker();
    }

    if ($('#buckaroo-form').length > 0)
    { 
        $('#buckaroo-form').submit();
    }


});

String.prototype.trunc = String.prototype.trunc ||
function(n){
    return this.length>n ? this.substr(0,n-1) : this;
};
   
   
// bugfix for internet explorer zodat onchange getriggered kan worden   
if ($.browser.msie) {  
  $(function() {  
    $('input:radio, input:checkbox').click(function() {  
      this.blur();  
      this.focus();  
    });  
  });  
} 

function number_format(number, decimals, dec_point, thousands_sep) {
  number = (number + '')
    .replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function(n, prec) {
      var k = Math.pow(10, prec);
      return '' + (Math.round(n * k) / k)
        .toFixed(prec);
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
    .split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '')
    .length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1)
      .join('0');
  }
  return s.join(dec);
}

function replaceContent(newContent)
{ 
    $('#container-content').empty().append(newContent);
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
